<script>
  import axios from 'axios';
  import { onMount } from 'svelte';
  import Button from '@smui/button';
  import Checkbox from '@smui/checkbox';
  import Textfield from '@smui/textfield';
  import Card, { PrimaryAction } from '@smui/card';
  import { Icon as CommonIcon, Label } from '@smui/common';
  import Paper, { Title, Subtitle, Content } from '@smui/paper';
  import SegmentedButton, { Segment } from '@smui/segmented-button';
  import FormField from '@smui/form-field';
  import { Stretch } from 'svelte-loading-spinners';
  import Dialog, { 
    Title as DialogTitle,
    Content as DialogContent,
    Actions as DialogActions 
  } from '@smui/dialog';

  // constants
  const axiosAPI = axios.create({
    // baseURL: 'http://localhost:3000',
    baseURL: 'https://api.podlodka.io/billingator',
    // baseURL:
    // "https://12f51979-1385-4208-90ea-114faae4ac3e.mock.pstmn.io/billingator/",
  });
  let bundleNames = ['Моряк', 'Морской волк', 'Адмирал'];
  let enBundleNames = ['sailor', 'sea_wolf', 'admiral'];
  let paymentTypes = {
    RUB: { currencyMark: '₽', currencyMultiplier: 1, paymentType: 'yookassa' },
    // EUR: { currencyMark: '€', currencyMultiplier: 0.01, paymentType: 'stripe' },
  };

  // form input
  let conferenceId;
  let abVariant = '';
  let abName = '';

  // user inputs
  let selectedCurrencyKey;
  $: selectedCurrency = paymentTypes[selectedCurrencyKey];
  let selectedBundle;

  let ticketsCount = 1;
  let needCertificate = false;
  let promocode = '';

  let customer = {
    email: '',
    firstname: '',
    lastname: '',
  };
  let participants = [];

  let policyChecked = false;

  // from server
  let mainOffer;
  let certificatePrice;
  let bundles;
  let isUnderMaintenance;

  // loading state
  let submitLoading = false;

  // computed
  let isCustomerAndRecepientsValid = false;

  let cartWasFullfilled = false;

  $: isSubmitButtonEnabled = isFormValid && !submitLoading;

  $: isFormValid =
    policyChecked &&
    selectedBundle &&
    ticketsCount > 0 &&
    isCustomerAndRecepientsValid;

  $: finalPrice = selectedBundle
    ? (selectedBundle.bundle_discounted_price +
        certificatePrice * needCertificate) *
      ticketsCount
    : 0;

  let fetchConferencesPromise;

  // Add new state variable near the top with other state variables
  let showSuccessMessage = false;

  onMount(async () => {
    conferenceId = document
      .getElementsByTagName('svelteapp')[0]
      .getAttribute('conference_id');
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('conference_id')) {
      conferenceId = urlParams.get('conference_id');
    }

    selectedCurrencyKey = urlParams.get('currency') || 'RUB';

    abVariant = getCookie('_wa_d') || '';
    abName = document.abName || '';
    fetchConferencesPromise = fetchConferences();
    handlePersonalDataChange();
  });

  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  async function checkMaintenanceStatus() {
    let result = await axiosAPI.get('/maintenance');
    return result.data['under_maintenance'];
  }

  function changeCurrency() {
    promocode = '';
    needCertificate = false;
    fetchConferences();
  }

  function promocodeButtonHandle() {
    if (selectedCurrencyKey != 'RUB') {
      alert(
        'Мы пока не успели реализовать промики для евро.\nРаботаем над этим 👨‍💻',
      );
      trackEvent('Euro promo request');
      return;
    }

    fetchConferences();
  }

  async function fetchConferences() {
    var offersInSelectedBundle;
    if (selectedBundle) {
      offersInSelectedBundle = selectedBundle.offers_in_bundle.map(
        (offer) => offer.offer_id,
      );
    }

    selectedBundle = undefined;

    isUnderMaintenance = await checkMaintenanceStatus();
    if (isUnderMaintenance) {
      return;
    }

    try {
      let result = await axiosAPI.get('/offers', {
        params: {
          product_id: conferenceId,
          promo: promocode,
          variant: abVariant,
          currency: selectedCurrencyKey,
        },
      });

      if (
        result.data[0] == undefined ||
        result.data[0].main_offer == undefined
      ) {
        return;
      }

      mainOffer = result.data[0].main_offer;
      bundles = result.data[0].bundles;
      certificatePrice = result.data[0].certificate_price;
      for (let i = 0; i < bundles.length; i++) {
        bundles[i].bundleName = bundleNames[i];
        bundles[i].bundleNameEn = enBundleNames[i];
      }

      if (offersInSelectedBundle) {
        selectedBundle = bundles.find(
          (bundle) =>
            JSON.stringify(
              bundle.offers_in_bundle.map((offer) => offer.offer_id),
            ) == JSON.stringify(offersInSelectedBundle),
        );
      }

      trackEvent('crewCheckout');
    } catch (error) {
      alert('Не прошел запрос');
      alert(error);
    }
  }

  const submitForm = async (paymentType) => {
    if (!conferenceId) {
      alert('Выберите конференцию');
      return;
    }

    if (!selectedBundle) {
      alert('Выберите один из вариантов покупки');
      return;
    }

    if (!ticketsCount) {
      alert('Выберите хотя бы один билет');
      return;
    }

    if (!policyChecked) {
      alert(
        'Для продолжения необходимо принять условия лицензионного соглашения',
      );
      return;
    }

    await handleCartFullfilled();

    trackEvent('crewPurchase', finalPrice);

    // GTM tracking stuff
    try {
      const itemId = mainOffer.product_id;
      const idx = itemId.lastIndexOf('_');
      const confId = id.slice(0, idx);    
      const season = mainOffer.product_season;

      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          value: finalPrice,
          currency: 'RUB',
          items: [{
            item_name: confId,
            item_id: itemId,
            price: finalPrice,
            discount: selectedBundle.bundle_initial_price - finalPrice,
            item_category: 'Конференции',
            item_category2: confId,
            item_category3: season
          }]
        }
      });
    } catch (error) {
      console.log(error);
    };
    // end of GTM tracking stuff

    try {
      submitLoading = true;
      const result = await axiosAPI.post(
        '/buy',
        createPaymentFormData(paymentType),
      );
      submitLoading = false;
      if (result.data.confirmation_url) {
        window.location.assign(result.data.confirmation_url);
        return;
      } else if (result.data.confirmation_status == 'free') {
        showSuccessMessage = true;
        return;
      } else if (result.data.Error) {
        alert(result.data.Error);
        return;
      } else {
        alert('Что-то пошло не так. Успешный ответ, но нет confirmation_url');
        return;
      }
    } catch (error) {
      submitLoading = false;
      alert(error);
    }
  };

  function handleTicketsCountChange() {
    if (!(ticketsCount > 0)) {
      ticketsCount = 1;
    }

    participants = [];
    // если покупают больше одного билета, то надо заводить participant под каждый билет
    if (ticketsCount > 1) {
      for (let i = 0; i < ticketsCount; i++) {
        participants = participants.concat({
          firstname: '',
          lastname: '',
          email: '',
        });
      }
    }

    handlePersonalDataChange();
  }

  function handlePersonalDataChange() {
    if (
      customer &&
      !(
        validateEmail(customer.email) &&
        customer.firstname &&
        customer.lastname
      )
    ) {
      isCustomerAndRecepientsValid = false;
      return;
    }

    if (ticketsCount > 1) {
      for (let i = 0; i < participants.length; i++) {
        const participant = participants[i];
        if (
          !(
            validateEmail(participant.email) &&
            participant.firstname &&
            participant.lastname
          )
        ) {
          isCustomerAndRecepientsValid = false;
          return;
        }
      }
    }

    isCustomerAndRecepientsValid = true;
  }

  async function handleCartFullfilled() {
    if (cartWasFullfilled || !validateEmail(customer.email)) {
      return;
    }

    cartWasFullfilled = true;
    var formData = {};

    formData['customer_email'] = customer.email;
    formData['customer_name'] = customer.firstname;
    formData['customer_surname'] = customer.lastname;
    formData['product_id'] = conferenceId;

    const result = await axiosAPI.post('/cart', formData);
  }

  function createPaymentFormData() {
    var formData = {};

    formData['customer_email'] = customer.email;
    formData['customer_name'] = customer.firstname;
    formData['customer_surname'] = customer.lastname;
    formData['need_certificate'] = needCertificate;
    formData['ab_name'] = abName;
    formData['ab_variant'] = abVariant;
    formData['payment_type'] = selectedCurrency.paymentType;
    const urlParams = new URLSearchParams(window.location.search);

    var utm = {};

    if (urlParams.get('utm_source')) {
      utm['source'] = urlParams.get('utm_source');
    }

    if (urlParams.get('utm_medium')) {
      utm['medium'] = urlParams.get('utm_medium');
    }

    if (urlParams.get('utm_campaign')) {
      utm['campaign'] = urlParams.get('utm_campaign');
    }

    if (urlParams.get('utm_term')) {
      utm['term'] = urlParams.get('utm_term');
    }

    if (urlParams.get('utm_content')) {
      utm['content'] = urlParams.get('utm_content');
    }

    if (Object.keys(utm).length !== 0) {
      formData['utm'] = utm;
    }

    if (promocode) {
      formData['promo'] = promocode;
    }

    // fields for analytical context
    let payment_method = ''
    if (selectedCurrencyKey == 'RUB') {
      payment_method = 'ru_card'
    } else {
      payment_method = 'eng_card'
    }

    let certRevenue = 0;
    if (needCertificate) {
      certRevenue = certificatePrice;
    }
    let withPromo = 'no';
    if (promocode) {
      withPromo = 'yes';
    }
    let analyticalContext = {
      client_id: getGAClientId(),
      client_id_duplicate: customer.email,
      product_id: mainOffer.product_id,
      product_area: mainOffer.product_area,
      product_season: mainOffer.product_season,
      offer_id: mainOffer.offer_id,
      payment_method: payment_method,
      currency: selectedCurrencyKey,
      certificate: needCertificate,
      certificate_revenue: certRevenue,
      promocode: withPromo,
      revenue: selectedBundle.bundle_initial_price,
      promocode_revenue: selectedBundle.bundle_discounted_price,
      tarif: selectedBundle.bundleNameEn
    };

    formData['analytical_context'] = analyticalContext;

    var orders = [];

    var finalCustomers = JSON.parse(JSON.stringify(participants));

    if (ticketsCount == 1) {
      finalCustomers.push(customer);
    }

    finalCustomers.forEach((customer) => {
      var order = {
        first_name: customer.firstname,
        last_name: customer.lastname,
        email: customer.email,
        offer_id: mainOffer.offer_id,
        additional_offer_ids: selectedBundle.offers_in_bundle
          .map((offer) => offer.offer_id)
          .filter((offer_id) => offer_id != mainOffer.offer_id),
      };
      orders.push(order);
    });
    formData['orders'] = orders;
    return formData;
  }

  function getGAClientId() {
    var clientId = '';
    const gaCookie = document.cookie.split('; ').find(row => row.startsWith('_ga='));
    if (gaCookie) {
      const value = gaCookie.split('=')[1];
      // Remove prefix like GA1.1.
      const parts = value.split('.');
      if (parts.length === 4) {
        // Remove GA1.1 and return the client ID
        clientId = `${parts[2]}.${parts[3]}`;
      } else {
        // If format is unexpected, just return full value without prefix
        clientId = value.replace(/^GA\d+\.\d+\./, '');
      }
    }
    return clientId;
  }

  function validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase()) && email.indexOf('+') === -1;
  }

  function trackEvent(event, value) {
    if (typeof gtag !== 'undefined' && mainOffer) {
      var payload = {
        event_category: 'payment_platform',
        event_label: mainOffer.product_name,
        value: value,
      };

      gtag('event', event, payload);
    }

    if (typeof fbq !== 'undefined' && mainOffer) {
      var payload = {
        content_category: 'payment_platform',
        content_name: mainOffer.product_name,
      };

      if (value) {
        payload['value'] = value;
        payload['currency'] = selectedCurrencyKey;
        payload['bundleName'] = selectedBundle.bundleName;
      }

      fbq('trackCustom', event, payload);
    }

    if (typeof ym !== 'undefined' && mainOffer) {
      var payload = {
        content_category: 'payment_platform',
        content_name: mainOffer.product_name,
      };

      if (value) {
        payload['order_price'] = value;
        payload['currency'] = selectedCurrencyKey;
        payload['bundleName'] = selectedBundle.bundleName;
      }

      ym(61441828, 'reachGoal', event, payload);
    }
  }

  // Add function to handle dialog close
  function handleSuccessClose() {
    showSuccessMessage = false;
  }
</script>

<main>
  <div class="box">
    {#await fetchConferencesPromise}
      <div class="paper-container">
        <Paper elevation={2}>
          <div class="loader">
            <Stretch size="100" unit="px" />
          </div>
        </Paper>
      </div>
      <div class="paper-container">
        <Paper elevation={2}>
          <div class="loader">
            <Stretch size="100" unit="px" />
          </div>
        </Paper>
      </div>
    {:then}
      {#if isUnderMaintenance}
        <p>Прямо сейчас мы шатаем форму на бою 😱</p>
      {:else if mainOffer}
        <div class="paper-container">
          <Paper elevation={2} class="form-paper">
            {#if Object.keys(paymentTypes).length > 1}
              <div class="currency_segment">
                <SegmentedButton
                  segments={Object.keys(paymentTypes)}
                  let:segment
                  singleSelect
                  bind:selected={selectedCurrencyKey}
                  on:click={changeCurrency}
                >
                  <Segment {segment}>
                    <span class="currency_segment_title"
                      >{paymentTypes[segment].currencyMark}</span
                    >
                  </Segment>
                </SegmentedButton>
              </div>
            {/if}
            <div class="title">
              <Title>{mainOffer.product_name}</Title>
              {#if mainOffer.description}
                <Subtitle>
                  {mainOffer.description}
                </Subtitle>
              {/if}
            </div>
            <Content>
              <div class="col-container">
                {#each bundles as bundle, i}
                  <div
                    class={bundles.length > 1 && i == 1
                      ? 'premium-card'
                      : 'other-card'}
                  >
                    <Card
                      style="height: 100%;"
                      class={bundles.length > 1 && i == 1
                        ? 'mdc-elevation--z7'
                        : 'mdc-elevation--z3'}
                    >
                      <PrimaryAction
                        on:click={() => (selectedBundle = bundle)}
                        padded
                        style="height: 100%;"
                      >
                        {#if bundle.bundleName}
                          <p class="bundle_title">
                            {bundle.bundleName}
                          </p>
                          <div class="divider" />
                        {/if}
                        <p class="discounted_price">
                          {bundle.bundle_discounted_price *
                            paymentTypes[bundle.bundle_currency]
                              .currencyMultiplier}{paymentTypes[
                            bundle.bundle_currency
                          ].currencyMark}
                        </p>
                        <p
                          class="initial_price"
                          style={bundle.bundle_initial_price ===
                          bundle.bundle_discounted_price
                            ? 'visibility:hidden'
                            : ''}
                        >
                          {bundle.bundle_initial_price *
                            paymentTypes[bundle.bundle_currency]
                              .currencyMultiplier}{paymentTypes[
                            bundle.bundle_currency
                          ].currencyMark}
                        </p>
                        {#if bundle.discount != 0}
                          <p class="discount">
                            -{Math.floor(bundle.discount * 100)}%
                          </p>
                        {/if}
                        <div
                          class="radio-box"
                          class:selected={selectedBundle &&
                            bundle === selectedBundle}
                        />
                        <ul class="offers-list">
                          {#each bundle.offers_in_bundle as offer}
                            <li class="offers-list-item">
                              <div
                                class="offers-list-discount-block"
                                style={offer.discounted_price ===
                                offer.initial_price
                                  ? 'visibility:hidden'
                                  : ''}
                              >
                                <p class="offers-list-discount-final-price">
                                  {offer.discounted_price *
                                    paymentTypes[offer.currency]
                                      .currencyMultiplier}{paymentTypes[
                                    offer.currency
                                  ].currencyMark}
                                </p>
                                <p class="offers-list-discount-initial-price">
                                  {offer.initial_price *
                                    paymentTypes[offer.currency]
                                      .currencyMultiplier}{paymentTypes[
                                    offer.currency
                                  ].currencyMark}
                                </p>
                              </div>
                              {offer.product_name}
                            </li>
                          {/each}
                        </ul>
                      </PrimaryAction>
                    </Card>
                  </div>
                {/each}
              </div>
              {#if certificatePrice && selectedCurrencyKey == 'RUB'}
                <div class="cert-form">
                  <FormField required>
                    <Checkbox bind:checked={needCertificate} />
                    <div class="cert-container" slot="label">
                      <div class="cert-container-cell">
                        <a
                          href="https://podlodka-crew.s3.eu-north-1.amazonaws.com/certs/common/certificate_crew.png"
                          target="_blank"
                        >
                          <img
                            src="https://podlodka-crew.s3.eu-north-1.amazonaws.com/certs/common/cert_thumb.jpeg"
                            alt="Certificate"
                            width="150"
                          />
                        </a>
                      </div>
                      <div class="cert-container-cell">
                        <div class="cert-title">
                          <b> Хочу сертификат об участии 🎖 </b>
                          (+900 ₽)
                        </div>
                        <div class="cert-subtitle">
                          Его можно показать рекрутерам или распечатать и
                          поставить в рамочку. Придет на почту после окончания
                          конференции.
                        </div>
                      </div>
                    </div>
                  </FormField>
                </div>
              {/if}
              <div
                class="margins"
                style="display: flex;
						align-items: center; flex-wrap: wrap"
              >
                <div class="tickets_number">
                  <Textfield
                    style="width: 80px"
                    class="shaped-outlined"
                    variant="outlined"
                    bind:value={ticketsCount}
                    on:change={handleTicketsCountChange}
                    label="Билеты"
                    type="number"
                  />
                </div>
                <div class="promocode_input">
                  <Textfield
                    variant="outlined"
                    label="Промокод"
                    style="width: 100%"
                    bind:value={promocode}
                  />
                </div>
                <Button
                  variant="unelevated"
                  on:click={promocodeButtonHandle}
                  disabled={!promocode}
                  class="fatButton"
                >
                  Применить промокод
                </Button>
              </div>
            </Content>

            <h3 class="smui-paper__subtitle" style="margin: 0px 15px 0px">
              {#if finalPrice == 0 && selectedBundle != null}
                Бесплатно
              {:else if selectedBundle != null}
                Итоговая цена:
                {finalPrice *
                  paymentTypes[selectedBundle.bundle_currency]
                    .currencyMultiplier}{paymentTypes[
                  selectedBundle.bundle_currency
                ].currencyMark}
              {/if}
            </h3>
            <h3 class="smui-paper__subtitle" style="margin: 0px 15px 0px">
              * Плейлисты размещены на платформе YouTube
            </h3>
          </Paper>
        </div>

        <div class="paper-container">
          <Paper elevation={2} class="form-paper">
            <div class="title">
              <Title>Данные покупателя</Title>
              {#if ticketsCount == 1}
                <Subtitle>Приглашение придет на указанную почту</Subtitle>
              {/if}
            </div>
            <div class="participant-info-row">
              <div class="participant-info">
                <Textfield
                  variant="outlined"
                  style="width:100%"
                  bind:value={customer.lastname}
                  on:change={handlePersonalDataChange}
                  input$autocomplete="family_name"
                  label="Фамилия"
                  required
                />
              </div>
              <div class="participant-info">
                <Textfield
                  id="input-firstname"
                  variant="outlined"
                  style="width:100%"
                  bind:value={customer.firstname}
                  on:change={handlePersonalDataChange}
                  input$autocomplete="first_name"
                  label="Имя"
                  required
                />
              </div>
              <div class="participant-info">
                <Textfield
                  variant="outlined"
                  style="width:100%"
                  bind:value={customer.email}
                  on:change={handlePersonalDataChange}
                  label=""
                  input$autocomplete="email"
                  type="email"
                >
                  <span slot="label"
                    ><CommonIcon
                      class="material-icons"
                      style="font-size: 1em; line-height: normal; vertical-align: middle;"
                    >
                      email
                    </CommonIcon>
                    Email</span
                  >
                </Textfield>
              </div>
            </div>

            {#if ticketsCount > 1}
              <div class="title">
                <Title>Данные участников</Title>
                <Subtitle>Приглашения придут на указанные почты</Subtitle>
              </div>
              {#each participants as customer}
                <div class="participant-info-row">
                  <div class="participant-info">
                    <Textfield
                      variant="outlined"
                      style="width:100%"
                      bind:value={customer.lastname}
                      on:change={handlePersonalDataChange}
                      input$autocomplete="family_name"
                      label="Фамилия"
                      required
                    />
                  </div>
                  <div class="participant-info">
                    <Textfield
                      id="input-firstname"
                      variant="outlined"
                      style="width:100%"
                      bind:value={customer.firstname}
                      on:change={handlePersonalDataChange}
                      input$autocomplete="first_name"
                      label="Имя"
                      required
                    />
                  </div>
                  <div class="participant-info">
                    <Textfield
                      variant="outlined"
                      style="width:100%"
                      bind:value={customer.email}
                      on:change={handlePersonalDataChange}
                      input$autocomplete="email"
                      label=""
                      type="email"
                    >
                      <span slot="label"
                        ><CommonIcon
                          class="material-icons"
                          style="font-size: 1em; line-height: normal; vertical-align: middle;"
                        >
                          email
                        </CommonIcon>
                        Email</span
                      >
                    </Textfield>
                  </div>
                </div>
              {/each}
            {/if}

            <div class="license">
              <FormField required>
                <Checkbox bind:checked={policyChecked} />
                <span slot="label"
                  >Я подтверждаю свое согласие с условиями
                  <a href="https://podlodka.io/crew-legal"
                    >Пользовательского соглашения</a
                  >
                  и
                  <a href="https://podlodka.io/data-processing"
                    >Обработки персональных данных</a
                  ></span
                >
              </FormField>
            </div>
            <Button
              style="margin: 0px 10px;"
              class="submit"
              variant="unelevated"
              on:click={() => submitForm('yookassa')}
              disabled={!isSubmitButtonEnabled}
            >
              Беру!
            </Button>
            {#if submitLoading}
              <div class="margins">
                <Stretch size="50" unit="px" />
              </div>
            {/if}
          </Paper>
        </div>
      {:else}
        <p>
          Что-то пошло не так. Напишите в
          <a href="https://t.me/podlodkacrew_support">чат саппорта</a>
        </p>
      {/if}
    {:catch error}
      <p style="color: red">{error.message}</p>
    {/await}
  </div>
  <div class="form-paper" />

  <!-- Add this dialog component near the end of the file, before </main> -->
  <Dialog
    bind:open={showSuccessMessage}
    aria-labelledby="success-dialog-title"
    aria-describedby="success-dialog-content"
    surface$style="width: 100%; max-width: 500px;"
  >
    <DialogTitle id="success-dialog-title">
      <div class="success-dialog-header">
        <CommonIcon class="material-icons success-icon">check_circle</CommonIcon>
        <span>Успешная покупка!</span>
      </div>
    </DialogTitle>
    <DialogContent id="success-dialog-content">
      <p>В ближайшее время на указанную почту придет письмо от podlodkacast@gmail.com с дальнейшими инструкциями.</p>
    </DialogContent>
    <DialogActions>
      <Button on:click={handleSuccessClose}>
        Закрыть
      </Button>
    </DialogActions>
  </Dialog>
</main>

<style>
  .margins {
    margin: 12px 30px 12px 10px;
  }
  .title {
    margin: 0px 10px;
  }
  .paper-container {
    padding: 9px 18px;
    max-width: 1024px;
    margin-left: auto;
    margin-right: auto;
  }

  .form-paper {
    padding: 24px 16px !important;
  }

  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 256px;
  }

  .box {
    max-height: auto;
    overflow: auto;
  }

  .tickets_number {
    margin-right: 12px;
  }

  .promocode_input {
    margin-right: 12px;
    display: flex;
    width: 20%;
  }

  .participant-info {
    display: inline-block;
    margin-right: 12px;
  }

  .participant-info-row {
    margin: 20px 30px 20px 10px;
    display: flex;
    align-items: top;
    flex-wrap: wrap;
  }

  .col-container {
    display: flex;
    width: 100%;
    align-items: stretch;
    align-content: stretch;
    margin: 24px 0px;
  }

  .premium-card {
    flex: 1.2;
    padding: 8px;
  }

  .other-card {
    flex: 1;
    padding: 8px;
    margin: 16px 0px;
  }

  .discounted_price {
    padding-top: 20px;
    text-align: center;
    font-size: 34px;
    margin: 0;
    font-family: Georgia, 'Times New Roman', Times, serif;
  }

  .initial_price {
    padding-top: 8px;
    text-align: center;
    width: auto;
    align-self: center;
    font-size: 17px;
    margin: 0;
    position: relative;
  }

  /* .mdc-segmented-button__segment {
    font-size: large;
  } */

  /* .currency_segment {
    flex: 1;
  } */

  .currency_segment {
    margin-right: 8px;
    float: right;
  }

  .currency_segment_title {
    font-size: 30px;
  }

  .initial_price::before {
    content: '';
    position: absolute;
    top: 60%;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: rgb(255, 62, 0);
    transform: rotate(-18deg);
  }

  .discount {
    text-align: center;
    position: absolute;
    top: 10px;
    right: 10px;
    margin: 0;
    background: rgb(255, 62, 0);
    padding: 5px;
    border-radius: 17px;
    font-size: 15px;
    font-weight: bold;
    color: white;
  }

  .bundle_title {
    text-align: center;
    font-size: x-large;
    font-family: Verdana;
    margin: 12px 0;
    margin: 8px 40px 12px 40px;
  }

  .divider {
    width: 50px;
    height: 2px;
    margin-left: auto;
    margin-right: auto;
    background-color: rgb(0 0 0 / 75%);
    border-radius: 4px;
  }

  .cert-form {
    border-width: 1px;
    border-radius: 8px;
    border-style: solid;
    border-color: rgb(158, 158, 158);
    margin: 20px 10px;
    padding: 4px;
  }

  .cert-container {
    display: flex;
    width: 100%;
  }

  .cert-container-cell {
    padding: 8px;
  }

  .cert-title {
    font-size: larger;
  }

  .cert-subtitle {
    font-size: medium;
  }

  .offers-list {
    list-style: none;
    padding: 0;
    margin: 0;
    padding-top: 16px;
    padding-left: 0 !important;
  }

  .offers-list-item {
    position: relative;
    padding-left: 24px;
    padding-top: 8px;
    padding-bottom: 6px;
    border-style: solid;
    border-color: #dedede;
    border-width: 2px;
    border-radius: 8px;
    margin: 8px 0px;
    overflow: auto;
  }

  .offers-list-item::before {
    content: '';
    background-image: url('static/assets/check_mark.svg');
    width: 16px;
    height: 16px;
    position: absolute;
    left: 4px;
    top: 11px;
    background-size: 100%;
  }

  .offers-list-discount-block {
    height: auto;
    margin-top: -8px;
    border-top-right-radius: 6px;
    border-bottom-left-radius: inherit;
    float: right;
    background-color: #81c14b;
  }

  .offers-list-discount-final-price {
    text-align: center;
    margin-block-start: -2px;
    margin-block-end: 0px;
    margin-inline-start: 6px;
    margin-inline-end: 6px;
    font-size: 12px;
    font-weight: bold;
    color: white;
    position: relative;
  }

  .offers-list-discount-initial-price {
    text-align: center;
    align-self: center;
    width: auto;
    margin-block-start: -10px;
    margin-block-end: -4px;
    margin-inline-start: 10px;
    margin-inline-end: 10px;
    font-size: 8px;
    color: white;
    position: relative;
  }

  .offers-list-discount-initial-price::before {
    content: '';
    position: absolute;
    top: 45%;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: rgb(255, 255, 255);
    transform: rotate(-18deg);
  }

  .radio-box {
    background-color: white;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 2px solid #333;
    position: absolute;
    top: 16px;
    left: 16px;
  }

  .radio-box.selected {
    box-shadow: inset 0 0 0px 6px white;
    background-color: #333;
  }

  .license {
    margin-bottom: 10px;
  }

  * :global(.fatButton) {
    height: 50px;
    margin-bottom: 0px;
  }

  @media (max-width: 860px) {
    .paper-container {
      padding: 4px 0;
    }

    .col-container {
      flex-direction: column;
    }

    .promocode_input {
      width: 100%;
      margin-bottom: 16px;
    }

    .tickets_number {
      width: 100%;
      margin-bottom: 16px;
    }

    .participant-info {
      width: 60%;
      min-width: 200px;
      margin-bottom: 10px;
    }

    .other-card {
      flex: 1;
      margin: 0px;
    }
  }

  @media (max-width: 550px) {
    .cert-container {
      flex-direction: column;
    }
  }

  .success-dialog-header {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .success-dialog-header :global(.success-icon) {
    color: #4CAF50;
    font-size: 2rem;
  }

  :global(.mdc-dialog .mdc-dialog__content) {
    padding: 20px 24px;
    font-size: 1.1rem;
    color: #666;
  }

  :global(.mdc-dialog .mdc-dialog__title) {
    padding: 24px 24px 0;
  }

  :global(.mdc-dialog .mdc-dialog__actions) {
    padding: 8px 24px 24px;
    justify-content: center;
  }
</style>
